import React from 'react';
import styles from './CurrentPlans.module.css';

const CurrentPlans = ({ plans, accountUrl }) => (
  <div className={styles.CurrentPlans}>
    <div className={styles.Header}>
      <h3 className={styles.Title}>Current Plans</h3>
      {accountUrl && (
        <a
          href={accountUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ManageLink}
        >
          Manage &rarr;
        </a>
      )}
    </div>
    {plans.map((plan, i) => (
      <div key={i} className={styles.PlanRow}>
        <span>{plan.plan_name}</span>
        {plan.is_on_hold && (
          <span className={styles.OnHoldBadge}>On Hold</span>
        )}
      </div>
    ))}
  </div>
);

export default CurrentPlans;
